/**
 * Fresh Pets Alpha
 *
 * @export alpha
 */
import ratios from './ratios'

const alpha = {
    dark: `rgba(0, 0, 0, ${ratios[4]})`,
    mid: `rgba(0, 0, 0, ${ratios[2]})`,
    light: `rgba(0, 0, 0, ${ratios[1]})`
}

export default alpha
